import { IFRResource } from "app/resources/ifrresource";
import { UserResource } from "app/resources/user/user-resource";

export class UserListResource extends IFRResource {

    public users: UserResource[];
}
